import { Dialog, DialogContent, DialogTitle, Button, DialogActions, Typography } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ReporteInsumosPdf from "./ReporteInsumosPdf";

const ReporteInsumosModal = ({ open, onClose, insumos }) => {
  return (
    <Dialog fullWidth maxWidth="xl" open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 1.5,
        }}
      >
        <PictureAsPdfIcon sx={{ color: "#fff", fontSize: 22 }} />
        <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, color: "#fff", fontSize: "1rem" }}>
          Reporte — Catálogo de Habilitados
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <ReporteInsumosPdf insumos={insumos} />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="secondary"
          variant="contained"
          sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600 }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReporteInsumosModal;
